<template>
  <div id="app">
    <router-view />
    <SecuritySensitiveVerifyHost />
  </div>
</template>

<script>
import SecuritySensitiveVerifyHost from '@/components/SecuritySensitiveVerifyHost.vue';

export default {
  components: {
    SecuritySensitiveVerifyHost,
  },
};
</script>

<style lang="scss">
body {
  background-color: #f5f5f5;
  min-width: 1280px;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.el-picker-panel {
  .el-month-table td.today .cell {
    color: #606266;
    font-weight: 400;
  }
}
.content-wrapper {
  background: #fff;
  border-radius: 8px;
  width: 1056px;
  padding: 33px;
  font-size: 14px;
  line-height: 1.5;
  color: #262626;
}
.el-message {
  z-index: 3000 !important;
}
</style>
